import React from 'react';
import { CheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
import { checkoutUrl, price, priceBefore, productName, totalBonuses, totalVolumes } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access', 'Teach wine studies with confidence starting today'];
export function FinalCta() {
  return <section className="bg-stage-deep py-16 sm:py-20" aria-labelledby="final-title" data-id="element-70" data-mp="1jbtylrlcl0ec">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-71" data-mp="1eetpf7t7bhj0">
        <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[.16em] text-sageGlow" data-id="element-72" data-mp="1t2ydysexqn9p">
          <ZapIcon className="h-4 w-4" aria-hidden="true" data-id="element-73" data-mp="1o3bonklu1gkj" /> {productName}
        </p>
        <h2 id="final-title" className="mx-auto mt-5 max-w-2xl text-balance text-3xl font-extrabold text-white sm:text-4xl" data-id="element-74" data-mp="223mi8vej199e">
          Created by wine education specialists, for educators worldwide
        </h2>

        <Countdown light className="mt-8" data-id="element-75" data-mp="n64b3n7yhqle" />

        <div className="mt-8 flex flex-col gap-5 rounded-xl border border-line bg-panel p-6 text-left shadow-lift sm:flex-row sm:items-center sm:justify-between" data-id="element-76" data-mp="n75npw4mel58">
          <p data-id="element-77" data-mp="x3ir5lpywdd6">
            <b className="block text-sm uppercase leading-tight text-ink" data-id="element-78" data-mp="x2qsu34zk1j7">{productName}</b>
            <span className="text-sm text-muted" data-id="element-79" data-mp="123521oibphit">
              {totalVolumes} volumes + {totalBonuses} bonuses · Instant access
            </span>
          </p>
          <div className="sm:text-right" data-id="element-80" data-mp="1b3jrn02blis4">
            <p className="text-sm text-muted" data-id="element-81" data-mp="1b2i4vybxz7uk">
              <span className="mr-2 line-through" data-id="element-82" data-mp="1b171w0qbm44i">{priceBefore}</span>
              <b className="text-base text-ink" data-id="element-83" data-mp="1fus0nuzqn24r">{price}</b>
            </p>
            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" size="sm" className="mt-2" data-id="element-84" data-mp="1ksbewuwfrewp">
              Get my Teacher Ready now
            </Button>
          </div>
        </div>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-mutedDark" data-id="element-85" data-mp="1tt9ijc2ypker">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-86" data-mp="3qsb1qkkivfgs">
              <CheckIcon className="h-4 w-4 text-sageGlow" aria-hidden="true" data-id="element-87" data-mp="3lx5jpwu8qkxz" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}